module.exports = __webpack_public_path__ + "static/media/activate.97cac9a4.svg";